var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.9162598,210.519455l30.8158875,30.815506l103.2550354-103.2552185 c8.4527283-8.5432129,8.4441833-22.3014145-0.019165-30.8341141L354.7321472,4l-31.0780945,31.0683327l66.2010193,65.8643799 H95.8166504c-26.7904434,0.0339355-48.4985085,21.7461166-48.527359,48.5365601v75.1935272h43.7317657v-79.9891205h298.7409973 L323.9162598,210.519455z M187.7113037,301.7200928l-30.8164673-30.8249207L53.6304054,374.1596375 c-8.4411926,8.5463867-8.4370079,22.2928772,0.0093994,30.8341064l103.2550354,103.2552185l30.824707-30.8154907 l-65.8081665-66.1828308h293.8891907c26.7952576-0.026123,48.5105286-21.7415161,48.5365601-48.5367737v-75.1933289h-43.7409668 v80.0451355H121.8645706L187.7113037,301.7200928z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.18ed1ae8.svg";
export { ForwardRef as ReactComponent };